import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import Checkbox from 'react-toolbox/lib/checkbox';
import Dropdown from 'react-toolbox/lib/dropdown';
import { list } from '~/actions/actions';

const defaults = {};

class PickupSettings extends Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata
      }
    };
  }

  componentDidMount() {
    list(this.props.dispatch, this.context.apiClient);
    this.onChange();
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  setOutdataValue(property, value) {
    this.setState(
      { outdata: { ...this.state.outdata, [property]: value } },
      this.onChange
    );
  }

  setOutdataValues(obj) {
    this.setState(
      { outdata: { ...this.state.outdata, ...obj } },
      this.onChange
    );
  }

  render() {
    return (
      <div>
        <Input
          value={this.state.outdata.title}
          onChange={val => this.setOutdataValue('title', val)}
          label="Title"
        />
        {/* <Checkbox
          checked={this.state.outdata.showQr}
          label="Show QR code"
          onChange={val => this.setOutdataValue('showQr', val)}
        /> */}
        <Dropdown
          onChange={val => this.setOutdataValue('actionId', val)}
          source={this.props.actions}
          value={this.state.outdata.actionId}
          label="Pickup action"
        />
        <Checkbox
          checked={this.state.outdata.hideButtons}
          label="Hide buttons"
          onChange={val => this.setOutdataValue('hideButtons', val)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actions: state
    .getIn(['actions', 'items'])
    .map(action => ({
      value: action.get('id'),
      label: action.get('name')
    }))
    .valueSeq()
    .toArray()
});

export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(PickupSettings);



// WEBPACK FOOTER //
// ./app/widgets.new/Pickup/settings.js